import script from "./BluetoothPrinter.vue?vue&type=script&setup=true&lang=js"
export * from "./BluetoothPrinter.vue?vue&type=script&setup=true&lang=js"

import "./BluetoothPrinter.vue?vue&type=style&index=0&id=39a23abd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39a23abd"]])

export default __exports__